export default {
    // Generic
    'generic.add': 'Bæta við',
    'generic.cancel': 'Hætta við',

    // BlockType
    'components.controls.blocktype.h1': 'H1',
    'components.controls.blocktype.h2': 'H2',
    'components.controls.blocktype.h3': 'H3',
    'components.controls.blocktype.h4': 'H4',
    'components.controls.blocktype.h5': 'H5',
    'components.controls.blocktype.h6': 'H6',
    'components.controls.blocktype.blockquote': 'blokkatilvitnun',
    'components.controls.blocktype.code': 'Kóði',
    'components.controls.blocktype.blocktype': 'Tegund blokk',
    'components.controls.blocktype.normal': 'Eðlilegt',

    // Color Picker
    'components.controls.colorpicker.colorpicker': 'Litavali',
    'components.controls.colorpicker.text': 'Texti',
    'components.controls.colorpicker.background': 'Hápunktar',

    // Embedded
    'components.controls.embedded.embedded': 'Innfelld',
    'components.controls.embedded.embeddedlink': 'Innbyggður hlekkur',
    'components.controls.embedded.enterlink': 'Sláðu inn tengil',

    // Emoji
    'components.controls.emoji.emoji': 'Emoji',

    // FontFamily
    'components.controls.fontfamily.fontfamily': 'Leturgerð',

    // FontSize
    'components.controls.fontsize.fontsize': 'Leturstærð',

    // History
    'components.controls.history.history': 'Saga',
    'components.controls.history.undo': 'Afturkalla',
    'components.controls.history.redo': 'Endurtaka',

    // Image
    'components.controls.image.image': 'Mynd',
    'components.controls.image.fileUpload': 'skrá upphleðslu',
    'components.controls.image.byURL': 'slóð',
    'components.controls.image.dropFileText': 'Slepptu skránni eða smelltu til að hlaða upp',

    // Inline
    'components.controls.inline.bold': 'Djarfur',
    'components.controls.inline.italic': 'Skáletrað',
    'components.controls.inline.underline': 'Undirstrika',
    'components.controls.inline.strikethrough': 'Strikið í gegn',
    'components.controls.inline.monospace': 'Monospace',
    'components.controls.inline.superscript': 'Yfirskrift',
    'components.controls.inline.subscript': 'Áskrift',

    // Link
    'components.controls.link.linkTitle': 'Titill hlekks',
    'components.controls.link.linkTarget': 'Tenglamarkmið',
    'components.controls.link.linkTargetOption': 'Opna tengil í nýjum glugga',
    'components.controls.link.link': 'Tengill',
    'components.controls.link.unlink': 'Aftengja',

    // List
    'components.controls.list.list': 'Listi',
    'components.controls.list.unordered': 'Óraðað',
    'components.controls.list.ordered': 'Pantaði',
    'components.controls.list.indent': 'Inndráttur',
    'components.controls.list.outdent': 'útaf',

    // Remove
    'components.controls.remove.remove': 'Fjarlægja',

    // TextAlign
    'components.controls.textalign.textalign': 'Textajafna',
    'components.controls.textalign.left': 'Vinstri',
    'components.controls.textalign.center': 'Miðja',
    'components.controls.textalign.right': 'Rétt',
    'components.controls.textalign.justify': 'Rökstyðja',
};
